module.exports = __webpack_public_path__ + "static/media/vocabularyTextOnly.a956d40a.png";